var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('app-header',{staticStyle:{"margin-bottom":"3%"}}),_c('app-rtap-header',{staticStyle:{"margin-bottom":"2%"}}),_c('app-how-it-works'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }